/**
 * App Component
 * Root component for the Faraid Calculator application
 */

import { FaraidCalculatorContainer } from '@components/FaraidCalculator';
import styles from './App.module.css';

/**
 * Main App component
 */
export const App = () => {
  return (
    <div className={styles.app}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h1 className={styles.title}>Kalkulator Faraid</h1>
          <p className={styles.subtitle}>
            Calculate Islamic inheritance distribution according to Shariah principles. 
            This tool helps determine each heir's rightful share.
          </p>
        </header>
        
        <main className={styles.main}>
          <FaraidCalculatorContainer />
        </main>
      </div>
    </div>
  );
};
